export function article() {
    const article = $('.article.content');
    const images = article.find('.wp-block-image');
    const clearfix = `<div class="clearfix"></div>`;
    const articleBottom = article.find('.article-bottom');

    if (articleBottom.length) {
        articleBottom.prepend(clearfix);
        articleBottom.find('.clearfix').addClass("without-padding").insertBefore(articleBottom);
    }


    images.each(function () {
        const imageWrap = $(this);
        const figure = imageWrap.find('figure');
        const figcaption = imageWrap.find('figcaption');


        if (!figcaption.length && (figure.hasClass("alignleft") || figure.hasClass("alignright"))) {
            let className = figure.attr('class');
            imageWrap.addClass(className);
            figure.removeAttr('class');

            imageWrap.prepend(clearfix);
            imageWrap.find('.clearfix').insertBefore(imageWrap);
        }
    });

    //article media slider
    const articleMediaSlider = article.find('.article-media-slider');
    const articleMediaSliderMedia = articleMediaSlider.find('.media');
    const articleMediaSliderNav = article.find('.article-media-slider-nav');
    const articleMediaSliderNavFirst = articleMediaSliderNav.find('.item').eq(0);
    const poster = `<img class="poster" src="${articleMediaSliderNavFirst.find('img').attr('src')}">`;
    articleMediaSliderMedia.attr('data-video', articleMediaSliderNavFirst.attr('data-video'));

    function createAndPlayVideo(element) {
        articleMediaSliderMedia.find('iframe').remove();
        const src = element.attr('data-video') + '?enablejsapi=1&autoplay=1';
        const iframe = '<iframe src="' + src + '" frameborder="0" allow="autoplay" allowfullscreen playsinline></iframe>'
        articleMediaSliderMedia.append(iframe);
    }

    articleMediaSliderMedia.append(poster);

    articleMediaSliderMedia.on('click', function () {
        $(this).find('svg').hide();
        articleMediaSliderMedia.find('.poster').hide();
        articleMediaSliderNavFirst.addClass('active');
        createAndPlayVideo($(this));
    });

    articleMediaSliderNav.find('.item').on('click', function () {
        if (!$(this).hasClass('active')) {
            articleMediaSliderMedia.find('.poster').hide();
            $(this).addClass('active').siblings().removeClass('active');
            createAndPlayVideo($(this));
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/article.js